'use strict';
// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('RecomendacaoObjectService', function($filter, StorageService, DecimalsService) {
  const service = {
    // eslint-disable-next-line complexity, max-lines-per-function
    convertToSend: function(recomendacao) {
      const result = {
        atividade: (recomendacao.atividade || {}).id,
        bico: recomendacao.bico,
        created_at: $filter('date')(new Date(), DATE_HOUR_ENGLISH_FORMAT),
        data_termino: $filter('date')(recomendacao.dataFinal, DATE_FORMAT),
        data_inicio: $filter('date')(recomendacao.dataInicial, DATE_FORMAT),
        horas_sem_chuva: recomendacao.horasSemChuva,
        id: recomendacao.id || null,
        latitude: recomendacao.latitude || null,
        longitude: recomendacao.longitude || null,
        observacao: recomendacao.observacao,
        periodo: recomendacao.atividade.periodo,
        ph: recomendacao.ph,
        precisao: recomendacao.precisao || null,
        pressao: recomendacao.pressao,
        propriedade: recomendacao.propriedade.id,
        recomendante: recomendacao.recomendante ? recomendacao.recomendante.id : StorageService.get(KEY_USER).id,
        responsavel: recomendacao.responsavel ? recomendacao.responsavel.id : 0,
        safra: recomendacao.safra.id,
        temperatura: recomendacao.temperatura,
        umidade: recomendacao.umidade,
        velocidade: recomendacao.velocidade,
        vento: recomendacao.vento,
        vazao: recomendacao.vazao,
        cronograma_fungicida_parameter_id: recomendacao.cronogramaFungicidaParameterId,
        taxa_remonte: recomendacao.taxaRemonte,
        litros_minutos: recomendacao.litrosMin,
        capacidade_tanque: recomendacao.capacidadeTanque,
        empreendimento_id: recomendacao.empreendimentoId
      };

      result.glebas = recomendacao.glebas.glebas.map(function(gleba) {
        return {
          id: gleba.id,
          area: DecimalsService.isDecimalV2Enabled() ? DecimalsService.truncateArea(gleba.area) : gleba.area,
          area_demarcada_id: gleba.areaDemarcadaId || null
        };
      });

      result.insumos = recomendacao.produtos.map(function(prod) {
        const dose = DecimalsService.isDecimalV2Enabled() ?
          DecimalsService.truncateDoseOrQuantity(prod.dose) :
          prod.dose;
        const quantidadeTotal = DecimalsService.isDecimalV2Enabled() ?
          DecimalsService.truncateDoseOrQuantity(prod.qtTotal) :
          null;
        const doseByTanque = DecimalsService.isDecimalV2Enabled() ?
          DecimalsService.truncateDoseOrQuantity(prod.doseByTanque) : prod.doseByTanque;

        return {
          id: prod.id,
          dose: dose,
          qt_total: quantidadeTotal,
          qt_dose_tanque: doseByTanque,
          unidade: prod.unidadeSelected.nomeSistema
        };
      });

      return result;
    },

    // eslint-disable-next-line complexity, max-lines-per-function
    convertToSendCorrecao: function(recomendacao) {
      const areaTotal = recomendacao.glebas.glebas.reduce(function(total, gleba) {
        return total + gleba.area;
      }, 0);
      const areaTotalRecomendada = DecimalsService.isDecimalV2Enabled() ?
        DecimalsService.truncateArea(areaTotal) :
        areaTotal.toFixed(2);
      const result = {
        data_termino: $filter('date')(recomendacao.dataFinal, DATE_FORMAT),
        data_inicio: $filter('date')(recomendacao.dataInicial, DATE_FORMAT),
        id: recomendacao.id || null,
        propriedade_id: recomendacao.propriedade.id,
        recomendante_id: recomendacao.recomendante ? recomendacao.recomendante.id : StorageService.get(KEY_USER).id,
        responsavel_id: recomendacao.responsavel ? recomendacao.responsavel.id : 0,
        safra_id: recomendacao.safra.id,
        empreendimento_id: recomendacao.atividade ? recomendacao.atividade.empreendimento :
          recomendacao.glebas.glebas[0].empreendimento, //período do empreendimento
        parametro_attributes: {
          velocidade_minima: (recomendacao.velocidade || {}).minima,
          velocidade_maxima: (recomendacao.velocidade || {}).maxima,
          velocidade_maxima_vento: (recomendacao.vento || {}).maxima,
          observacoes: recomendacao.observacao
        },
        area_total_recomendada: areaTotalRecomendada,
        operacao_id: recomendacao.operacao_id || recomendacao.operacao
      };

      result.glebas_attributes = recomendacao.glebas.glebas.map(function(gleba) {
        return {
          gleba_id: gleba.id || gleba.gleba_cd_gleba,
          area_recomendada: DecimalsService.isDecimalV2Enabled() ? DecimalsService.truncateArea(gleba.area) : gleba.area
        };
      });

      const areaRecomendada = result.area_total_recomendada;
      result.produtos_attributes = recomendacao.produtos.map(function(prod) {
        const dose = DecimalsService.isDecimalV2Enabled() ?
          DecimalsService.truncateDoseOrQuantity(prod.dose) : prod.dose;
        const qtTotal = DecimalsService.isDecimalV2Enabled() ?
          DecimalsService.truncateDoseOrQuantity(prod.qtTotal) :
          areaRecomendada * prod.dose;
        return {
          item_estoque_id: prod.id || prod.produto.item_id,
          item_estoque_tipo: prod.tipo || prod.produto.tipo_item,
          qt_dose: dose,
          unidade_id: prod.unidadeSelected.nomeSistema,
          qt_total: qtTotal
        };
      });

      return result;
    },

    convertToSendAdubacao: function(recomendacao) {
      const obj = service.convertToSendCorrecao(recomendacao);
      obj.atividade_id = recomendacao.atividade.id;
      return obj;
    },

    // eslint-disable-next-line complexity, max-lines-per-function
    convertToObject: function(recomendacao) {
      const temRecomendacao = recomendacao && recomendacao.id;
      const result = !temRecomendacao ? {} : {
        bico: recomendacao.bico,
        horasSemChuva: Number(recomendacao.horas_sem_chuva) || null,
        dataFinal: moment(recomendacao.data_termino).toDate(),
        dataInicial: moment(recomendacao.data_inicio).toDate(),
        createdAt: moment(recomendacao.created_at).toDate(),
        id: recomendacao.id,
        latitude: recomendacao.latitude,
        longitude: recomendacao.longitude,
        motivo_rejeicao: recomendacao.motivo_rejeicao,
        observacao: recomendacao.observacao,
        operacao: recomendacao.operacao_id,
        ph: {
          maximo: Number(recomendacao.ph.maximo) || null,
          minimo: Number(recomendacao.ph.minimo) || null
        },
        precisao: recomendacao.precisao,
        pressao: {
          valor: Number(recomendacao.pressao.valor) || null,
          unidade: recomendacao.pressao.unidade || null
        },
        produtos: recomendacao.insumos.map(function(insumo) {
          insumo.qtTotal = insumo.qt_total;
          insumo.doseByTanque = insumo.qt_dose_tanque;
          return insumo;
        }),
        propriedade: recomendacao.propriedade,
        recomendante: recomendacao.recomendante,
        responsavel: recomendacao.responsavel,
        safra: recomendacao.safra,
        selects: {
          atividade: recomendacao.atividade,
          glebas: recomendacao.glebas.map((g) => {
            const areaTotalCalculated = g.area_total / ((recomendacao.taxa_remonte / 100) + 1);
            const areaTotal = g.area_total_original || areaTotalCalculated;
            const area = DecimalsService.isDecimalV2Enabled() ?
              DecimalsService.truncateArea(areaTotal) : areaTotal.toFixed(2);

            return Object.assign(g, { area_total: area });
          })
        },
        situacao: recomendacao.situacao,
        situacao_pt_br: recomendacao.situacao_pt_br,
        status: recomendacao.status,
        temperatura: {
          maxima: Number(recomendacao.temperatura.maxima) || null,
          minima: Number(recomendacao.temperatura.minima) || null
        },
        velocidade: {
          minima: Number((recomendacao.velocidade || {}).minima) || null,
          maxima: Number((recomendacao.velocidade || {}).maxima) || null
        },
        vento: {
          maxima: Number((recomendacao.vento || {}).maxima) || null
        },
        umidade: {
          maxima: Number(recomendacao.umidade.maxima) || null,
          minima: Number(recomendacao.umidade.minima) || null
        },
        vazao: Number(recomendacao.vazao),
        taxaRemonte: Number(recomendacao.taxa_remonte),
        litrosMin: Number(recomendacao.litros_minutos) || null,
        capacidadeTanque: Number(recomendacao.capacidade_tanque) || null
      };

      return result;
    },

    // eslint-disable-next-line complexity, max-lines-per-function
    convertToObjectCorrecao: function(recomendacao) {
      const temRecomendacao = recomendacao && recomendacao.id;
      const result = !temRecomendacao ? {} : {
        dataFinal: moment(recomendacao.data_termino).toDate(),
        dataInicial: moment(recomendacao.data_inicio).toDate(),
        id: recomendacao.id,
        observacao: recomendacao.parametro.observacoes,
        operacao: (recomendacao.operacao || {}).id,
        produtos: recomendacao.produtos.map(function(produto) {
          return {
            produto: produto.produto,
            dose: DecimalsService.isDecimalV2Enabled() ?
              DecimalsService.truncateDoseOrQuantity(Number(produto.qt_dose)) : Number(produto.qt_dose),
            qtTotal: DecimalsService.isDecimalV2Enabled() ?
              DecimalsService.truncateDoseOrQuantity(Number(produto.qt_total)) : null,
            unidade: produto.unidade
          };
        }),
        propriedade: recomendacao.propriedade,
        responsavel: recomendacao.responsavel,
        safra: recomendacao.safra,
        selects: {
          atividade: recomendacao.atividade,
          glebas: recomendacao.glebas.map((g) => {
            if (g.gleba) {
              return Object.assign(g, g.gleba);
            }
            return g;
          })
        },
        situacao: recomendacao.situacao,
        status: recomendacao.status,
        velocidade: {
          minima: Number(recomendacao.parametro.velocidade_minima) || null,
          maxima: Number(recomendacao.parametro.velocidade_maxima) || null
        },
        vento: {
          maxima: Number(recomendacao.parametro.velocidade_maxima_vento) || null
        }
      };

      return result;
    },

    convertToObjectAdubacao: function(recomendacao) {
      return service.convertToObjectCorrecao(recomendacao);
    }
  };

  return service;
});
